import { af_utils } from './utils';

(function() {
  if (window.location.origin === 'https://alfaleads.eu') return;

  var COOKIE_NAME = 'cookie_sources';
  var hasCookie = !!localStorage.getItem(COOKIE_NAME);

  if (!hasCookie) {
    var query = window.location.search.replace('?', '');
    var params = af_utils.queryStringToJSON(query);

    if (Object.keys(params).length) {
      var value = JSON.stringify(params);
      localStorage.setItem(COOKIE_NAME, value);
    }
  }
})();
